<template>
    <div>
        <div class="top-menu-icon">
            <div v-if="! opened" @click="open">
                <IconMenu height="36" classes="inline-block" />
            </div>
        </div>
        <div class="top-menu" :class="{ 'invisible lg:visible': ! opened }" v-on-clickaway="close">
            <div class="holder">
                <div class="flexer lg:container">
                    <BigButton @clicked="$router.push({ name: 'login' })">
                        {{ $t('login') }}
                    </BigButton>
                    <BigButton @clicked="$router.push({ name: 'register' })">
                        {{ $t('register') }}
                    </BigButton>
                    <div class="night-mode">
                        <div>{{ $t('nightMode') }}</div>
                        <div>
                            <label class="form-switch">
                              <input type="checkbox"  :checked="mode == 'on'" 
                                    @change="save($event.target.checked ? 'on' : 'off')">
                              <i></i>
                            </label>
                        </div>
                    </div>
                    <div class="oferta">
                        <router-link :to="{ name: 'oferta' }">{{ $t('oferta') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconMenu from '@/components/visual/icons/IconMenu'
import BigButton from '@/components/visual/BigButton'
import { mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
export default {
    components: { IconMenu, BigButton },
    mixins: [ clickaway ],
    data() {
        return {
            opened: false,
        }
    },
    methods: {
        open() {
            setTimeout(() => {this.opened = true}, 50)
        },
        close() {
            if (this.opened) 
                this.opened = false
        },
        save(mode) {
            this.$store.dispatch('nightmode/set', mode)
        },
    },
    computed: {
        ...mapState('nightmode', ['mode']),
    },
}
</script>

<i18n locale="ru" lang="yaml">
    login: "Вход"
    register: "Регистрация"
    oferta: "Публичная оферта"
    nightMode: "Темная тема"
</i18n>

<i18n locale="en" lang="yaml">
</i18n>
